import { CATEGORIES_CREATE, CATEGORIES_CREATE_ERROR, CATEGORIES_CREATE_LOAD_STATUS, CATEGORIES_FETCH_ALL, CATEGORIES_SET_TO_DEFAULT, CATEGORIES_UPDATE } from "../actions/typeKey"

const defatultState = {
    categories : [],
    categoryDetail : null,
    loadingStatus : false,
    updateStatus : null,
    errorMessage : '',
}

function categoriesReducer(state = defatultState,action){
    switch (action.type){
        case CATEGORIES_FETCH_ALL :
            return {
                ...state,
                categories : action.payload
            }
        case CATEGORIES_CREATE :
            return {
                ...state,
                categoryDetail : action.payload
            }
        case CATEGORIES_CREATE_LOAD_STATUS :
            return {
                ...state,
                loadingStatus : action.payload
            }
        case CATEGORIES_CREATE_ERROR : 
            return {
                ...state,
                errorMessage : action.payload
            }
        case CATEGORIES_UPDATE : 
            return {
                ...state,
                updateStatus : action.payload
            }
        case CATEGORIES_SET_TO_DEFAULT : 
            return {
                ...state,
                categoryDetail : null,
                updateStatus : null,
            }
        default : 
            return state
    }
}

export default categoriesReducer